import { render, staticRenderFns } from "./PolicyNei.vue?vue&type=template&id=cbd03074&scoped=true"
import script from "./PolicyNei.vue?vue&type=script&lang=js"
export * from "./PolicyNei.vue?vue&type=script&lang=js"
import style0 from "./PolicyNei.vue?vue&type=style&index=0&id=cbd03074&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd03074",
  null
  
)

export default component.exports